import React from 'react';
import {
  Box,
  Typography,
  Button,
  Tooltip,
  IconButton,
  Container,
  Card,
  CardContent,
  Link,
  Stack,
} from '@mui/material';
import { Person, PersonAdd, MenuBook } from '@mui/icons-material';
import LandingPageLayoutMobile from '../../layout/LandingPageLayoutMobile';
import { useNavigate } from 'react-router-dom';
import logoImg from '../../assets/logo.png';

export default function DeskStudioLandingPageMobileRev() {
  const navigate = useNavigate();

  return (
    <LandingPageLayoutMobile>
      {/* HERO */}
      <Box
        id="hero"
        sx={{
          py: 8,
          textAlign: 'center',
          background: '#fff',
          color: '#2742F5',
        }}
      >
        <img src={logoImg} alt="DeskStudio" style={{ maxWidth: '120px', marginBottom: '16px' }} />
        <Typography variant="h4" sx={{ mb: 1, fontWeight: 700 }}>
          DeskStudio
        </Typography>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Il gestionale delle scadenze fiscali pensato per studio e contribuenti (partite IVA individuali)
        </Typography>
        <Typography variant="h6" sx={{ mb: 4 }}>
          Scadenze fiscali sotto controllo, senza stress. Più tempo per altre attività
        </Typography>

        <Stack direction="row" justifyContent="center" spacing={2} sx={{ mb: 2 }}>
          <Tooltip title="Accedi">
            <IconButton
              sx={{ bgcolor: '#2742F5', color: '#fff', '&:hover': { bgcolor: '#1B34D1' } }}
              onClick={() => navigate('/login')}
              size="large"
            >
              <Person />
            </IconButton>
          </Tooltip>
          <Tooltip title="Registrati">
            <IconButton
              sx={{ bgcolor: '#2742F5', color: '#fff', '&:hover': { bgcolor: '#1B34D1' } }}
              onClick={() => navigate('/register')}
              size="large"
            >
              <PersonAdd />
            </IconButton>
          </Tooltip>
          <Tooltip title="Manuale utente">
            <IconButton
              sx={{ bgcolor: '#2742F5', color: '#fff', '&:hover': { bgcolor: '#1B34D1' } }}
              onClick={() => window.open(`${process.env.PUBLIC_URL}/manualeUtente.pdf`, '_blank')}
              size="large"
            >
              <MenuBook />
            </IconButton>
          </Tooltip>
        </Stack>

        <Stack direction="row" spacing={2} justifyContent="center">
          <Button onClick={() => navigate('/privacy')} sx={{ color: '#2742F5' }}>
            Privacy
          </Button>
          <Button onClick={() => navigate('/terms')} sx={{ color: '#2742F5' }}>
            Termini e Condizioni
          </Button>
        </Stack>
      </Box>

      {/* PROBLEMA */}
      <Container id="problema" sx={{ py: 4, textAlign: 'center' }}>
        <Typography variant="h4" sx={{ mb: 2, color: '#2742F5' }}>
          Sai sempre dove sono le tue scadenze o quelle dei tuoi clienti?
        </Typography>
        <Typography variant="h6" sx={{ mb: 4, color: '#2742F5' }}>
          Documenti sparsi, scadenze perse, telefonate infinite. DeskStudio organizza tutto in un unico posto.
        </Typography>
      </Container>

      {/* SOLUZIONI */}
      <Container id="soluzioni" sx={{ py: 4 }}>
        <Typography variant="h6" sx={{ mb: 2, textAlign: 'center' }}>
          Cosa fa DeskStudio
        </Typography>
        <Stack spacing={2}>
          {[
            'Documenti centralizzati',
            'Scadenze sotto controllo',
            'Accesso cliente facile',
            'Avvisi automatici',
            'Marcatura pagamento rapida',
            'Report e statistiche',
            'Autenticazione a due fattori (OTP), storage dei dati su S3, hashing',
          ].map((text, idx) => (
            <Card key={idx} sx={{ bgcolor: '#fff', textAlign: 'center', borderRadius: 2, boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
              <CardContent>
                <Typography>{text}</Typography>
              </CardContent>
            </Card>
          ))}
        </Stack>
      </Container>

      {/* TESTIMONIANZE */}
      <Container id="testimonianze" sx={{ py: 4 }}>
        <Typography variant="h6" sx={{ mb: 2, textAlign: 'center' }}>
          Cosa dicono i nostri clienti
        </Typography>
        <Stack spacing={2}>
          {[
            '“Con DeskStudio ho finalmente la visione completa dei documenti dei miei clienti. Risparmio 3 ore a settimana!” – Marco, Commercialista',
            '“Mai più scadenze perse, il mio studio è finalmente organizzato.” – Laura, Commercialista',
          ].map((t, idx) => (
            <Card key={idx} sx={{ borderRadius: 2, boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
              <CardContent>
                <Typography variant="body2">{t}</Typography>
              </CardContent>
            </Card>
          ))}
        </Stack>
      </Container>

      {/* PREZZI */}
      <Container id="prezzi" sx={{ py: 4, textAlign: 'center' }}>
        <Typography sx={{ mb: 2 }}>
          Prezzi chiari e accessibili. Per ogni opzione di abbonamento sono possibili sconti. Gli abbonamenti 'Studio XX' e
          'Plus' forniscono l'accesso alla applicazione con il profilo "STUDIO', per la gestione dei fascicoli dei contribuenti
          (Partite IVA individuali). L'abbonamento Single è dedicato al singolo CONTRIBUENTE che vuole gestire in autonomia
          il suo fascicolo, e/o interagire con uno STUDIO. I contribuenti associati a uno studio possono gestire il loro
          fascicolo usufruendo per il primo anno di un canone annuo 'Single' con uno sconto di 60€. Lo studio a sua volta
          avrà uno sconto di 10€ per ogni suo contribuente che sottoscrive l' abbonamento single. Lo sconto sarà applicato
          al primo rinnovo di contratto. L'associazione di un contribuente ad uno studio avviene inserendo nel form di
          registrazione il codice invito fornito loro dallo studio.
        </Typography>

        <Typography sx={{ mb: 2, textAlign: 'left' }}>
          <Typography>Perchè acquistare DeskStudio?</Typography>
          <Typography>- funzionalità potenti ma semplici</Typography>
          <Typography>- risolve i vostri problemi</Typography>
          <Typography>- è un prodotto nuovo in continua evoluzione che acquisirà nuove funzionalità, anche su proposta degli utenti.</Typography>
        </Typography>

        <Stack spacing={2}>
          {[
            { plan: 'Base', price: '129€/anno', desc: '1 contribuente' },
            { plan: 'Studio 10', price: '349€/anno', desc: 'Fino a 10 contribuenti gestiti' },
            { plan: 'Studio 20', price: '549€/anno', desc: 'Fino a 20 contribuenti gestiti' },
            { plan: 'Studio 50', price: '899€/anno', desc: 'Fino a 50 contribuenti gestiti' },
            { plan: 'Studio 150', price: '1799€/anno', desc: 'Fino a 150 contribuenti gestiti' },
            { plan: 'Studio Plus', price: '2799€/anno', desc: 'Illimitati' },
          ].map((p, idx) => (
            <Card key={idx} sx={{ textAlign: 'center', borderRadius: 2, boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
              <CardContent>
                <Typography variant="h6">{p.plan}</Typography>
                <Typography variant="h5" sx={{ my: 1 }}>
                  {p.price}
                </Typography>
                <Typography sx={{ mb: 1 }}>{p.desc}</Typography>
                <Stack direction="row" justifyContent="center">
                  <Tooltip title="Registrati">
                    <IconButton
                      sx={{ bgcolor: '#2742F5', color: '#fff', '&:hover': { bgcolor: '#1B34D1' } }}
                      onClick={() => navigate('/sitopubblico/demorequest')}
                      size="large"
                    >
                      <PersonAdd />
                    </IconButton>
                  </Tooltip>
                </Stack>
              </CardContent>
            </Card>
          ))}
        </Stack>
      </Container>

      {/* CONTATTI */}
      <Container id="contatti" sx={{ py: 10 }}>
        <Typography variant="h4" sx={{ mb: 3, textAlign: 'center', color: '#000000' }}>
          Contattaci su:
        </Typography>
        <Typography variant="h5" sx={{ mb: 3, textAlign: 'center', color: '#000000' }}>
          <Link href="mailto:info@deskstudio.it" color="inherit" underline="always">
            info@deskstudio.it
          </Link>
        </Typography>
      </Container>

      {/* FOOTER */}
      <Box sx={{ bgcolor: '#333', color: '#fff', py: 3, textAlign: 'center' }}>
        <Typography variant="body2">DeskStudio © 2026</Typography>
      </Box>
    </LandingPageLayoutMobile>
  );
}
